import { getCDNImageUrl } from '@/helpers/cdn';

import type { IConfig } from '../CrownMarch25/helpers';

export const config: IConfig = {
  default: {
    translation: 'slotwinLP',
    defaultBonusCode: 'slotwin',
    fsCount: 40,
    validate: '10.10.2026',
  },
};

export const FIRST_SPIN_REWARD_FS = 10;

// Only this LP needs weight 800, so request it here, not in the shared default.
export const WORK_SANS_WEIGHTS = [400, 700, 800, 900];

export const IMAGE_SRC_PATH = '/lp/slot-machine-26';

export const img = (src: string) => getCDNImageUrl(`${IMAGE_SRC_PATH}/${src}`);

// Pause after the rigged first win settles, before swapping the machine
// for the offer — lets the win register before the reveal.
export const OFFER_REVEAL_DELAY_MS = 300;
// The very first spin is rigged to land 3 diamonds on the middle payline,
// so the reel hooks new visitors with an immediate win. The bonus spin
// unlocked from the first offer is rigged to land 3 sevens, which reveals
// a second offer summarizing both prizes.
export const FIRST_SPIN_SYMBOL = 'diamond';
export const BONUS_SPIN_SYMBOL = 'seven';
// Stable reference so a fresh array literal doesn't defeat SlotReel's memo.
export const FORCED_SYMBOLS = [FIRST_SPIN_SYMBOL, BONUS_SPIN_SYMBOL];

export enum OfferStage {
  Slot = 0,
  FirstReward = 1,
  SecondReward = 2,
  FinalReward = 3,
}

// Which offer card to reveal after each rigged symbol's spin settles.
export const OFFER_STAGE_BY_SYMBOL: Record<
  string,
  OfferStage.FirstReward | OfferStage.SecondReward
> = {
  [FIRST_SPIN_SYMBOL]: OfferStage.FirstReward,
  [BONUS_SPIN_SYMBOL]: OfferStage.SecondReward,
};

export const getSecondOfferFs = (fsCount: number) => {
  const secondOfferFs = fsCount - FIRST_SPIN_REWARD_FS;
  // A too-small total (e.g. a tampered ?fs= query) can't cover the first
  // spin's reward — fall back to half of it rather than show 0/negative FS.
  return secondOfferFs > 0 ? secondOfferFs : FIRST_SPIN_REWARD_FS / 2;
};
